<template>
    <div>
     <b-modal size="xl" :id="ModalId" :visible="true" centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" @close="this.emitEventCancel" @ok="handleOk" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
      
         <Loading v-bind:IsLoading="this.Load" /> 
        <form ref="form_EditNote" @submit.stop.prevent="handleSubmit">
        <MdTitle v-bind:Text="'General Information'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-bind:StyleProp="'margin: 0 !important;'"/>
        <b-row>
          <b-col lg="4" md="4" sm="12">            
                 <MdLookup
                    v-bind:Label="'Billing'"
                    v-bind:ModelCode="Billing"
                    v-bind:ModelDescription="bDescription"
                    v-bind:RefCode="'cpt'"
                    v-bind:Api="'CPTs'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"                    
                    :IsDisabled="false"    
                    :SearchTitle="'Billing'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iEditModalNotes'"
                    :GetValues="onCodeConditionOkModal"                    
                    :SearchFieldCode="'cpt'"                     
                />
            </b-col>
             <b-col lg="4" md="4" sm="12">            
                  <MdSelect
                      v-bind:Label="'TypicalUnits'"
                      v-bind:Options="TypicalUnitList"
                      v-bind:FieldDescription="'description'"
                      v-bind:Tag="'NoteTypicalUnits'"
                      v-bind:IsDisabled="false"
                      v-bind:AllowEmpty="true"
                      v-bind:RequireEvent="true"
                      v-bind:FieldCode="'recID'"
                      v-bind:Model="TypicalUnit"                       
                      v-bind:Multiple="false"
                      :Input="ChangeDropDownTypicalUnits"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">            
                 <MdCheckBox
                    v-bind:Label="'Telehealth'"
                    v-bind:Name="'checkbox-Telehealth'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="Telehealth"
                    v-bind:isReadOnly="false"/>
            </b-col>

        </b-row>
      </form>
     </b-modal>  
     
    </div>
</template>
 
 <script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Loading from '@/components/template/loading/Loading'
import ISetup from '@/services/isetup.service'
import TypicalUnitService from '@/services/typicalunits.service'
import { EventBus } from '@/event-bus.js';
 

 export default {
    name: 'IniModalEditNote',   
    components: { Loading },
    mixins: [ShowMessage, DBFunctions], 
    props: {
        ModalId: String,
        TitleWindow: String,
        RecId:[Number,String]
    },
   
   data(){
     return {
        Load: false,
        Telehealth:false,
        TypicalUnitList:[],
        TypicalUnit:{recID:null,description:""},
        ReadOnly:true,  
        Billing:"", 
        bDescription:"",    
     }
   },
 
   methods:{

    handleOk($event){   
        $event.preventDefault();          
         this.UpdateNoteModal();
    },

    ChangeDropDownPriorAutho(item){
        this.PriorAutho = item ? item.code : "";
    },

    ChangeDropDownUnits(item){
        this.UnitsAs = item ? item.code : "";
    },

    ChangeDropDownTypicalUnits(item){
      this.TypicalUnit = item ? item : {recID:null,description:""};
    },

    onCodeConditionOkModal(result){
      var type = result.FieldName;        
             switch (type) {
                case "cpt": 
                  this.Billing = result.code; 
              //    this.parameter.BillingCode = result.code;                   
                  this.bDescription = result.description; 
                //  this.getNotesList();
                  break;
             }
    },

    async getSetupNote(){   
      this.Load = true;
      await ISetup.GetNote(this.RecId)
      .then((response) => {      
           if (response.status == "200") { 
                let data = response.data;   
                this.Billing = data.billingCode;
                this.bDescription = data.billingCodeDescription;
               // this.TypicalUnit.recID = data.typicalUnit;
                //this.TypicalUnit.description = data.typicalUnitDescription;
                this.TypicalUnit = {recID:data.typicalUnit,description:data.typicalUnitDescription};
                EventBus.$emit('ChangedDrop', {model:this.TypicalUnit,Tag:"NoteTypicalUnits"});
                this.Telehealth = data.teleHealth;

                this.Load = false;
           }
           this.Load = false;
      })
      .catch(error => {
        this.Load = false;
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    async getTypicalUnits(){   
      this.Load = true;
     let param = {
      SearchCriteria:null,
      PageSize:null,
      PageNumber:null,
     }
      await TypicalUnitService.getAll(param)
      .then((response) => {      
           if (response.status == "200") { 
                this.TypicalUnitList = response.data;               
                this.Load = false;
           }
           this.Load = false;
      })
      .catch(error => {
        this.Load = false;
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

  
    async UpdateNoteModal(){   
      this.Load = true;
      let data = {
        BillingCode:this.Billing,
        TypicalUnit:this.TypicalUnit.recID,
        TeleHealth:this.Telehealth,       
      } 
      await ISetup.UpdateNote(this.RecId,data)
      .then((response) => {      
           if (response.status == "200") { 
               this.Load = false;
               setTimeout(() => this.ResetModal(), 100);
           }
           this.Load = false;
      })
      .catch(error => {
        this.Load = false;
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    emitEventCancel(){
         this.ResetModal();
    },

    ResetModal(){
        this.$emit('OnResetModal',true);
    },
     
   },

    
  async mounted(){
    //await this.getWileyTxGoals();
    await this.getTypicalUnits();
    this.getSetupNote();
   },
 };
 </script>

